import { useState } from 'react';
import { Link } from 'react-router-dom';
import SEO from '../components/SEO';
import QuoteSection from '../components/QuoteSection';
import LightboxModal from '../components/LightboxModal';
import { companyInfo } from '../data/siteData';
import { imageUrl } from '../lib/images';

export default function TraebeklaedteLaagerPage() {
  const [lightboxIndex, setLightboxIndex] = useState(null);

  const images = [
    { src: "/_assets/fb-img-1760014068393.jpg", title: "Træbeklædt låge" },
    { src: "/_assets/thumbnail-img20250926084028.jpg", title: "Træbeklædt låge i stålramme" },
    { src: "/_assets/thumbnail-img20250926084045-0.jpg", title: "Træbeklædt låge montering" },
  ];

  return (
    <>
      <SEO
        title="Træbeklædte låger | Hovendals"
        description="Naturlige, stabile og æstetiske En træbeklædt låge er det perfekte match til dit træhegn eller som et varmt og indbydende element i haven. Træets naturlige struktur og farvetoner giver et smukt, klassisk udtryk, som harmonerer med både moderne og traditionelle omgivelser. Hos Hovendals ApS oplever vi stor efterspørgsel på træbeklædte låger, fordi de kombinerer funktionalitet med et tidløst design. Få et uforpligtende tilbud her"
        ogImage="/_assets/thumbnail-img20250926084045.jpg"
      />

      {/* Hero */}
      <section className="relative py-20 bg-slate-900 text-white overflow-hidden">
        <div className="absolute inset-0 z-0 opacity-25">
          <img
            src={imageUrl("/_assets/thumbnail-img20250926084045.jpg", "width=1600,quality=80,format=auto")}
            alt="Træbeklædte låger"
            className="w-full h-full object-cover"
          />
        </div>
        <div className="max-w-[1440px] mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
          <div className="max-w-3xl space-y-4">
            <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full text-xs font-bold uppercase tracking-wider bg-[#004fa4]/20 text-[#c2ccdf] border border-[#004fa4]/30">
              <i className="fa-sharp fa-solid fa-tree" aria-hidden="true"></i>
              <span>Naturlig æstetik</span>
            </div>
            <h1 className="text-3xl sm:text-4xl lg:text-5xl font-extrabold tracking-tight text-white leading-tight">
              Træbeklædte låger
            </h1>
            <p className="text-base sm:text-lg text-slate-300 leading-relaxed font-normal">
              Naturlige, stabile og æstetiske låger til have og indgang.
            </p>
          </div>
        </div>
      </section>

      {/* Content Section */}
      <section className="py-16 md:py-20 bg-white">
        <div className="max-w-[1440px] mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center mb-16">
            <div className="space-y-6">
              <div>
                <span className="text-xs font-bold uppercase tracking-wider text-[#004fa4]">Naturlige, stabile og æstetiske</span>
                <h2 className="text-2xl sm:text-3xl font-extrabold text-slate-900 tracking-tight mt-1">
                  Låger med træbeklædning og solid konstruktion
                </h2>
              </div>
              <p className="text-slate-700 leading-relaxed text-base">
                En træbeklædt låge er det perfekte match til dit træhegn eller som et varmt og indbydende element i haven. Træets naturlige struktur og farvetoner giver et smukt, klassisk udtryk, som harmonerer med både moderne og traditionelle omgivelser. Hos Hovendals ApS oplever vi stor efterspørgsel på træbeklædte låger, fordi de kombinerer funktionalitet med et tidløst design.
              </p>

              <div className="flex flex-wrap gap-4 pt-2">
                <a
                  href={`tel:${companyInfo.phoneFormatted}`}
                  className="px-6 py-3 rounded-lg bg-[#004fa4] hover:bg-[#183e7f] text-white font-medium text-sm shadow-sm transition-all flex items-center gap-2"
                >
                  <i className="fa-sharp fa-solid fa-phone" aria-hidden="true"></i>
                  <span>Ring: {companyInfo.phone}</span>
                </a>
                <Link
                  to="/kontakt"
                  className="px-6 py-3 rounded-lg bg-slate-900 hover:bg-slate-800 text-white font-bold text-sm transition-all flex items-center gap-2"
                >
                  <i className="fa-sharp fa-solid fa-paper-plane" aria-hidden="true"></i>
                  <span>Få et uforpligtende tilbud her</span>
                </Link>
              </div>
            </div>

            <div className="relative rounded-2xl overflow-hidden shadow-xl border-4 border-white bg-slate-100">
              <img
                src={imageUrl("/_assets/fb-img-1760014068393.jpg", "width=800,quality=85,format=auto")}
                alt="Træbeklædt låge"
                className="w-full h-auto object-cover"
              />
            </div>
          </div>

          {/* Galleri */}
          <div className="mb-16">
            <h3 className="text-2xl font-bold text-slate-900 mb-2">
              Eksempler på træbeklædte låger
            </h3>
            <p className="text-sm text-slate-600 mb-6">
              Klik på et billede for at forstørre.
            </p>
            <div className="grid grid-cols-1 sm:grid-cols-3 gap-6 max-w-4xl">
              {images.map((img, idx) => (
                <div
                  key={idx}
                  onClick={() => setLightboxIndex(idx)}
                  className="group relative h-64 rounded-xl overflow-hidden bg-slate-100 cursor-pointer shadow-sm hover:shadow-md transition-all"
                >
                  <img
                    src={imageUrl(img.src, "width=600,quality=80,format=auto")}
                    alt={img.title}
                    className="w-full h-full object-cover transition-transform duration-300 group-hover:scale-105"
                    loading="lazy"
                  />
                  <div className="absolute inset-0 bg-slate-950/40 opacity-0 group-hover:opacity-100 transition-opacity flex items-center justify-center text-white">
                    <span className="p-2.5 rounded-full bg-[#143463]/90 text-white text-sm">
                      <i className="fa-sharp fa-solid fa-magnifying-glass-plus" aria-hidden="true"></i>
                    </span>
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* Kontakt */}
          <div className="bg-slate-50 rounded-2xl p-8 sm:p-10 border border-slate-200/80 space-y-4">
            <h3 className="text-2xl font-bold text-slate-900">
              Kontakt os og få et uforpligtende tilbud træbeklædte låger
            </h3>
            <p className="text-slate-700 leading-relaxed text-base">
              Ønsker du at få et uforpligtende tilbud på Træbeklædt låge? Så er du velkommen til at kontakte os på <a href={`tel:${companyInfo.phoneFormatted}`} className="text-[#004fa4] font-bold hover:underline">{companyInfo.phone}</a> eller send os en mail på <a href={`mailto:${companyInfo.email}`} className="text-[#004fa4] font-bold hover:underline">{companyInfo.email}</a> også vender vi tilbage til dig hurtigst muligt.
            </p>
          </div>
        </div>
      </section>

      {/* Quote Section */}
      <QuoteSection />

      {/* Lightbox modal */}
      <LightboxModal
        images={images}
        currentIndex={lightboxIndex}
        onClose={() => setLightboxIndex(null)}
        onNavigate={(index) => setLightboxIndex(index)}
      />
    </>
  );
}
